import { Link } from "react-router-dom";
import logo from './logo-inovacao.png'


function Topbar() {

    

    return(
        <nav className="navbar navbar-expand-lg navbar-dark  bg-dark shadow-sm">
            <div class="container">
                <a class="navbar-brand fw-bold d-flex align-items-center" href="/home">
                    <img src={logo} alt="logo" style={{ height: 40, width: 40 }} className="me-2" />
                    <h3 className="text-white m-0">SUITI</h3>
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNav">
            {/* <div className="p-3">
                <div className="d-flex align-items-center mb-4">
                <img src={logo} alt="logo" style={{ height: 40, width: 40 }} className="me-2" />
                <h3 className="text-white m-0">SUITI</h3>
                </div> */}
                <ul class="navbar-nav ms-auto gap-3">
                    <li className="nav-item">
                        <Link to="/home" className="nav-link text-white">
                        <i className="bi bi-house-door me-2"></i>
                        Home
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/ideias" className="nav-link text-white">
                        <i className="bi bi-lightbulb me-2"></i>
                        Ideias
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/campanhas" className="nav-link text-white">
                        <i className="bi bi-list-ul me-2"></i>
                        Campanhas
                        </Link>
                    </li>

                    {((sessionStorage.getItem("tipousuario") == 1) || (sessionStorage.getItem("tipousuario") == 3))  &&
                        <li className="nav-item">
                        <Link to="/tarefas" className="nav-link text-white">
                            <i className="bi bi-table me-2"></i>
                            Tarefas
                        </Link>
                        </li>
                    }

                    {(sessionStorage.getItem("tipousuario") == 3)  &&
                        <>
                        <li className="nav-item">
                            <Link to="/usuarios" className="nav-link text-white">
                            <i className="bi bi-person me-2"></i>
                            Usuários
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="#" className="nav-link text-white">
                            <i className="bi bi-gear me-2"></i>
                            Configurações
                            </Link>
                        </li>
                        </>
                    }
                    {sessionStorage.getItem("tipousuario")  ?
                        <li>
                            <Link to="/logout" className="nav-link text-warning">
                                <i className="bi bi-box-arrow-right me-2 text-warning"></i>
                                Log out 
                            </Link>
                        </li>
                    :
                        <li>
                            <div className="d-flex">
                                <Link to="/login" className="nav-link text-warning">
                                    <i className="bi bi-box-arrow-in-right me-2 text-warning"></i>
                                    Login 
                                </Link>

                                <Link to="/register" className="nav-link text-warning">
                                    <i className="bi bi-person-plus me-2 text-warning"></i>
                                    Registro 
                                </Link>
                            </div>
                        </li>
                    }
                </ul>
                </div>
            </div>
        </nav>

        // <nav classNameName="navbar navbar-static-top fundocinzamedio border-bottom" role="navigation" style={{marginBottom: 0, marginLeft: -20, marginRight: -20}}>
        //     <div classNameName="navbar-header">
        //             <a classNameName="navbar-minimalize minimalize-styl-2 btn btn-primary " href=""><i classNameName="fa fa-bars"></i> </a>
        //             <form role="search" classNameName="navbar-form-custom" action="search_results.html">
        //                 <div classNameName="form-group">
        //                     <input type="text" placeholder="Procurar..." classNameName="form-control" name="top-search" id="top-search" />
        //                 </div>
        //             </form>
                    
        //     </div>
        //     <ul classNameName="nav navbar-top-links navbar-right">
        //                 <li>
        //                     <span classNameName="m-r-sm text-muted welcome-message">Olá, {sessionStorage.getItem("nomeusuario")}</span>
        //                 </li>
                        
        //                 <li>
        //                   <Link to="/logout"><i classNameName="fa fa-sign-out"></i> Log out </Link>
        //                 </li>
        //     </ul>

        // </nav>
    )
}

export default Topbar